<ng-template #errorLoading>
    <app-preloader/>
</ng-template>
<ng-container *ngIf="appSettingService.value, else errorLoading">
    <app-navbar *ngIf="!authService.isAuthenticated()" />
    
    <ng-container *ngIf="authService.value">
        <app-admin-navbar *ngIf="authService.isAuthenticated() && (authService.value.role.code_name == 'comite' || authService.value.role.code_name == 'comite') || (authService.value.role.code_name == 'super_admin' || authService.value.role.code_name == 'super_admin')" />
        <app-verificator-navbar *ngIf="authService.isAuthenticated() && (authService.value.role.code_name == 'validator' || authService.value.role.code_name == 'validator')" />
        <app-evaluator-navbar *ngIf="authService.isAuthenticated() && (authService.value.role.code_name == 'evaluator' || authService.value.role.code_name == 'evaluator')" />
    </ng-container>

    <router-outlet />

    <app-footer />
</ng-container>
